import { h } from 'preact'
import UserAvatar from '../../../preact-components/User/UserAvatar'
import AnonymousUserCell from './AnonymousUserCell'
import Icon from '../../../preact-components/assets'
import globals from '../../../utils/globals'

const UserCell = (accessor: string, iconSize: number = 16, openInNewTab: boolean = true, showDestinationIcon: boolean = false) => {
  return (props: any) => {
    const userFromProps = props[accessor]
    if (!userFromProps) {
      return null
    }

    const { id, username, avatar } = userFromProps
    const user = {
      id,
      name: username,
      avatar,
      url: `/member/profile?userid=${id}`
    }

    let linkProps = {}

    if (openInNewTab) {
      linkProps = {
        target: '_blank',
        rel: 'noreferrer'
      }
    }

    return (
      <div className='overview__table-user'>
        {!username
          ? <AnonymousUserCell customClass='overview__table-user' iconSize={iconSize} />
          : <div className='flex-center'>
            <UserAvatar user={user} openInNewTab={openInNewTab} style={{ width: `${iconSize}px`, height: `${iconSize}px` }} />
            <a href={user.url} {...linkProps}>{username}</a>
          </div>}
        {(showDestinationIcon && username) &&
          <a
            href={`${globals('communityUrl')}/members/${username}-${id}`} target='_blank' rel='noreferrer'
            style='margin-left: auto'
          >
            <Icon icon='externalLink' width={16} height={16} customClass='flex-center' />
          </a>}
      </div>
    )
  }
}

export default UserCell
